import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donations/recurring";

export const Route = createFileRoute("/admin/_donations/recurring")({
  component: Page,
});
